<div class="container">
    <app-template [title]="'Report Template'">
        <div class="all">
            <form [formGroup]="Form" (ngSubmit)="onSubmit($event)">

                <!-- <h1 class="title">Create Template</h1> -->

              <span class="input">
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input formControlName="name" matInput placeholder="Name">
                  </mat-form-field>
              </span>

                
              <span class="input">
                <mat-form-field>
                    <mat-label>Description</mat-label>
                    <input formControlName="description" matInput placeholder="description..">
                  </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                    <mat-label>Module Code</mat-label>
                    <input formControlName="moduleCode" matInput placeholder="module code..">
                  </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                    <mat-label>Report Type</mat-label>
                    <mat-select formControlName="reportType" matNativeControl required>
                      <mat-option *ngFor="let template of templates" [value]="template.Id">
                        {{template.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                    <mat-label>Query Text</mat-label>
                    <input formControlName="queryText" matInput placeholder="query text..">
                  </mat-form-field>
                </span>
          
            
              <button *ngIf="!isLoading" type="submit" class="button" mat-raised-button color="primary" [disabled]="Form.invalid"> Create </button>
              <button *ngIf="isLoading" type="submit" class="button" mat-raised-button color="primary"  ><i class="fa fa-spin fa-spinner"></i>&nbsp;Create</button>
              <a routerLink="/report" class="waves-effect pull-right" style="margin-left: 20px;">
                <button type="button" class="button" mat-raised-button color="primary"> Back</button>
              </a>
            </form>
          </div>
    </app-template>
</div>